import React, { useState } from "react";
import "./PromoBanner.css";

const PromoBanner = () => {
  const [copied, setCopied] = useState(false);


  const handleCopy = () => {
    navigator.clipboard.writeText("ASTRO20");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="pb-section">
      {/* Floating decorative orbs */}
      <div className="pb-orb pb-orb1"></div>
      <div className="pb-orb pb-orb2"></div>
      <div className="pb-orb pb-orb3"></div>

      {/* Stars decoration */}
      <div className="pb-stars">
        {[...Array(6)].map((_, i) => (
          <span key={i} className={`pb-star pb-star${i + 1}`}>✦</span>
        ))}
      </div>

      <div className="pb-inner">
        {/* Left side */}
        <div className="pb-left">
          <div className="pb-badge">
            <span className="pb-badge-icon">🏷️</span>
            <span>SPECIAL OFFER</span>
          </div>

          <h2 className="pb-heading">
            Start Your{" "}
            <span className="pb-highlight">First Chat for FREE!</span>{" "}
            Get Expert Guidance Instantly
          </h2>

          <p className="pb-sub">
            Unlock the secrets of your future with our expert astrologers at a special discounted price.
          </p>
          {/* <h2 className="pb-heading">
            Get upto{" "}
            <span className="pb-highlight">20% OFF</span>{" "}
            on your next consultation
          </h2>

          <p className="pb-sub">
            Unlock the secrets of your future with our expert astrologers at a special discounted price.
          </p> */}

          <div className="pb-features">
            {/* <span className="pb-feat">✓ First consult free</span> */}
            {/* <span className="pb-feat">✓ 500+ experts</span> */}
            <span className="pb-feat">✓ 24/7 available</span>
          </div>
        </div>

        {/* Right side — promo card */}
        {/* <div className="pb-right">
          <div className="pb-promo-card">
            <p className="pb-promo-label">USE PROMO CODE</p>

            <div className="pb-code-row">
              <span className="pb-code">ASTRO20</span>
              <button
                className={`pb-copy-btn ${copied ? "pb-copied" : ""}`}
                onClick={handleCopy}
              >
                {copied ? (
                  <>✓ COPIED</>
                ) : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    COPY
                  </>
                )}
              </button>
            </div>

            <p className="pb-validity">*Valid for a limited time only. T&C apply.</p>

            <div className="pb-notch pb-notch-left"></div>
            <div className="pb-notch pb-notch-right"></div>
          </div> */}
        {/* </div> */}
      </div>
    </section>
  );
};

export default PromoBanner;